module.exports = __webpack_public_path__ + "img/16l003-02.c596f896.png";